import GcsDocsFeature from '../../features/docs/gcs-feature';

export default function GcsDocsPage() {
  return <GcsDocsFeature />;
}
